module.exports = __webpack_public_path__ + "img/pds_guide_m.772d9473.png";